import { safeDefine } from "../../registration/safe-define.js";
import { DialogTitleElement } from "../../ui/dialog/title.js";
//#region src/define/ui/dialog-title.ts
safeDefine(DialogTitleElement);
//#endregion
